import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6f928c6d = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _68bf85b4 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _33b402d0 = () => interopDefault(import('..\\pages\\path.vue' /* webpackChunkName: "pages_path" */))
const _d37ca124 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _0db1c5a8 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _1ec104a2 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _3b18b80b = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _40edfd4e = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _40fc14cf = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _411843d1 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _41265b52 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _75d4388f = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _28443585 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _415ffb5c = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _ffaf8a9e = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _78447e48 = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _335b60bc = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _eeff5864 = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _7ae7d6fb = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _35e37a53 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _2bcc6e37 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _6f928c6d,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _68bf85b4,
    name: "have-a-card"
  }, {
    path: "/path",
    component: _33b402d0,
    name: "path"
  }, {
    path: "/rejection",
    component: _d37ca124,
    name: "rejection"
  }, {
    path: "/success",
    component: _0db1c5a8,
    name: "success"
  }, {
    path: "/unlock",
    component: _1ec104a2,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _3b18b80b,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _40edfd4e,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _40fc14cf,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _411843d1,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _41265b52,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _75d4388f,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _28443585,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _415ffb5c,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _ffaf8a9e,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/patient-information",
    component: _78447e48,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _335b60bc,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _eeff5864,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _7ae7d6fb,
    name: "need-a-card-success"
  }, {
    path: "/patient/patientSearch",
    component: _35e37a53,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _2bcc6e37,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
